module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['bo-list', {
      single: _vm.single
    }]
  }, [_vm._t("default", null, {
    "list": _vm.list,
    "single": _vm.single,
    "showAll": _vm.allAudience,
    "municipalities": _vm.municipalities,
    "showTotalResults": _vm.showTotalResults,
    "resetSingle": _vm.resetSingle,
    "data": _vm.parameters
  }), _vm._v(" "), (!_vm.single) ? _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    class: {
      active: _vm.viewType === 'list'
    },
    on: {
      "click": function($event) {
        return _vm.setViewType('list')
      }
    }
  }, [_c('span', [_c('sky-svg', {
    attrs: {
      "name": "burger"
    }
  }), _vm._v("\r\n\t\t\t\t\tVis tilbud på liste\r\n\t\t\t\t")], 1)]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.viewType === 'map'
    },
    on: {
      "click": function($event) {
        return _vm.setViewType('map')
      }
    }
  }, [_c('span', [_c('sky-svg', {
    attrs: {
      "name": "map-marker"
    }
  }), _vm._v("\r\n\t\t\t\t\tVis tilbud på kort\r\n\t\t\t\t")], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.single) ? _vm._t("back") : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "results",
    class: _vm.showDetailed && _vm.single ? 'results-full' : ''
  }, [(_vm.viewType === 'list' || _vm.single) ? _c('ul', [_vm._l((_vm.list.results.items), function(item, index) {
    return (!_vm.showDetailed || !_vm.single) ? _c('bo-list-item', {
      key: index,
      attrs: {
        "item": item
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.showDetailed && _vm.single) ? _c('bo-list-item', {
    attrs: {
      "detailed": true,
      "item": _vm.single
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.single && !_vm.list.results.items.length) ? _c('li', [_c('em', [_vm._v("Der var ingen resultater for din søgning. Prøv med\r\n\t\t\t\t\tnogle andre parametre.")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.viewType === 'map' && !_vm.single) ? _c('div', {
    staticClass: "maps-view"
  }, [_c('button', {
    staticClass: "watch-nationWide",
    on: {
      "click": _vm.jumpToList
    }
  }, [_vm._v("Se landsdækkende tilbud")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.infoWindow) ? _c('div', {
    staticClass: "info-window"
  }, [_c('button', {
    on: {
      "click": _vm.closeMarker
    }
  }, [_c('svg', {
    attrs: {
      "id": "Layer_1",
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('g', {
    attrs: {
      "id": "Line_5",
      "data-name": "Line 5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.5,19a1.5,1.5,0,0,1-1.06055-2.56055l15-15a1.49984,1.49984,0,0,1,2.1211,2.1211l-15,15A1.49514,1.49514,0,0,1,2.5,19Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticStyle: {
      "isolation": "isolate"
    },
    attrs: {
      "id": "Line_6",
      "data-name": "Line 6",
      "opacity": "0.501"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.5,19a1.49514,1.49514,0,0,1-1.06055-.43945l-15-15a1.49984,1.49984,0,0,1,2.1211-2.1211l15,15A1.5,1.5,0,0,1,17.5,19Z"
    }
  })])])]), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.infoWindow.name)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.infoWindow.description)
    }
  }), _vm._v(" "), (_vm.infoWindow.externalUrl) ? _c('a', {
    attrs: {
      "href": "#"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.infoWindow.externalUrl)
    }
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.infoWindow.type && _vm.infoWindow.type.name) ? _c('div', [_c('sky-svg', {
    attrs: {
      "name": "offer-type"
    }
  }), _vm._v(" " + _vm._s(_vm.infoWindow.type.name) + "\r\n\t\t\t\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('sky-svg', {
    attrs: {
      "name": "offer-audiences"
    }
  }), _vm._v(" "), _vm._l((_vm.infoWindow.audiences), function(audience) {
    return (_vm.infoWindow.audiences.length) ? _c('span', [_vm._v(_vm._s(audience.name)), _c('em', [_vm._v(",")])]) : _vm._e()
  }), _vm._v(" "), (!_vm.infoWindow.audiences.length) ? _c('span', [_vm._v("\r\n\t\t\t\t\t\t\t\t\tIkke udfyldt\r\n\t\t\t\t\t\t\t\t")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(!_vm.infoWindow.organization.phone != null && _vm.infoWindow.organization.phone != '') ? _c('div', [_c('sky-svg', {
    attrs: {
      "name": "phone"
    }
  }), _vm._v(" " + _vm._s(_vm.infoWindow.organization.phone || 'Ikke udfyldt') + "\r\n\t\t\t\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.infoWindow.organization.email != null && _vm.infoWindow.organization.email != '') ? _c('div', [_c('sky-svg', {
    attrs: {
      "name": "mail"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.infoWindow.organization.email || '#'
    }
  }, [_vm._v(_vm._s(_vm.infoWindow.organization.email || 'Ikke udfyldt'))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(!_vm.infoWindow.location.parent != null && _vm.infoWindow.location.parent != '') ? _c('div', [_c('sky-svg', {
    attrs: {
      "name": "map-marker"
    }
  }), _vm._v(" " + _vm._s(_vm.infoWindow.location.parent || 'Ikke udfyldt') + "\r\n\t\t\t\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('sky-svg', {
    attrs: {
      "name": "offer-address"
    }
  }), _vm._v(" "), (!_vm.infoWindow.organization.name && !_vm.infoWindow.organization.address && !_vm.infoWindow.organization.zipcode && !_vm.infoWindow.organization.city) ? [_vm._v("Ikke\r\n\t\t\t\t\t\t\t\t\tudfyldt")] : _vm._e(), _vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.infoWindow.organization.name)), _c('br'), _vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.infoWindow.organization.address)), (_vm.infoWindow.organization.address) ? [_vm._v(",")] : _vm._e(), _vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.infoWindow.organization.zipcode) + " " + _vm._s(_vm.infoWindow.organization.city) + "\r\n\t\t\t\t\t\t\t")], 2)])])]) : _vm._e()]), _vm._v(" "), _c('gmap-map', {
    attrs: {
      "center": _vm.mapCenter,
      "zoom": 8,
      "options": _vm.mapOptions.settings,
      "v:bind": "listMap.results.items",
      "map-type-id": "roadmap"
    }
  }, [_c('gmap-cluster', {
    attrs: {
      "styles": _vm.mapOptions.clusterStyles
    }
  }, _vm._l((_vm.listMap.results.items), function(item, index) {
    return (item.location.center) ? _c('gmap-marker', {
      key: index,
      attrs: {
        "icon": "/6682bo/static/maps-marker.png",
        "clickable": true,
        "position": item.location.center
      },
      on: {
        "click": function($event) {
          return _vm.clickMarker(item)
        }
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('div', {
    class: ['map-list', {
      'no-results': !_vm.listNation.results.items.length
    }]
  }, [_c('h1', [_vm._v("Landsdækkende tilbud")]), _vm._v(" "), _c('ul', [_vm._l((_vm.listNation.results.items), function(item, index) {
    return (item.location.parent === 'Landsdækkende') ? _c('bo-list-item', {
      key: index,
      attrs: {
        "item": item
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.single && !_vm.listNation.results.items.length) ? _c('li', [_c('em', [_vm._v("Der var ingen resultater for din søgning.\r\n\t\t\t\t\t\t\tPrøv med nogle andre parametre.")])]) : _vm._e()], 2)])], 1) : _vm._e(), _vm._v(" "), (_vm.viewType !== 'map' && (_vm.list.results.pagination.total > _vm.list.results.items.length)) ? _c('div', {
    staticClass: "more"
  }, [_c('div', [(_vm.list.preferences.pagination && _vm.list.results.pagination.offset != 0) ? _c('button', {
    staticClass: "prev button",
    domProps: {
      "innerHTML": _vm._s(_vm.messagePrevious)
    },
    on: {
      "click": _vm.previous
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.list.results.items.length >= _vm.list.results.pagination.limit) ? _c('button', {
    staticClass: "next button",
    domProps: {
      "innerHTML": _vm._s(_vm.messageNext)
    },
    on: {
      "click": _vm.next
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.viewType === 'map' && (_vm.listNation.results.pagination.total > _vm.listNation.results.items.length)) ? _c('div', {
    staticClass: "more"
  }, [_c('div', [(_vm.listNation.preferences.pagination && _vm.listNation.results.pagination.offset != 0) ? _c('button', {
    staticClass: "prev button",
    domProps: {
      "innerHTML": _vm._s(_vm.messagePrevious)
    },
    on: {
      "click": _vm.previous
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.listNation.results.items.length >= _vm.listNation.results.pagination.limit) ? _c('button', {
    staticClass: "next button",
    domProps: {
      "innerHTML": _vm._s(_vm.messageNext)
    },
    on: {
      "click": _vm.next
    }
  }) : _vm._e()])]) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/vue-loader/lib/template-compiler?{"id":"data-v-3b448bac"}!./scripts/bo-list/bo-list.html
// module id = 267
// module chunks = 1